webpackJsonp(["pages.projects"],{

/***/ "./pages/projects/index.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__project__ = __webpack_require__("./pages/projects/project.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__shortcuts_navigation__ = __webpack_require__("./shortcuts_navigation.js");



document.addEventListener('DOMContentLoaded', function () {
  new __WEBPACK_IMPORTED_MODULE_0__project__["a" /* default */](); // eslint-disable-line no-new
  new __WEBPACK_IMPORTED_MODULE_1__shortcuts_navigation__["a" /* default */](); // eslint-disable-line no-new
});

/***/ }),

/***/ "./pages/projects/project.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function($) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_js_cookie__ = __webpack_require__("../../../node_modules/js-cookie/src/js.cookie.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_js_cookie___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_js_cookie__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__locale__ = __webpack_require__("./locale/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__lib_utils_url_utility__ = __webpack_require__("./lib/utils/url_utility.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__lib_utils_axios_utils__ = __webpack_require__("./lib/utils/axios_utils.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__flash__ = __webpack_require__("./flash.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__project_select__ = __webpack_require__("./project_select.js");
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

/* eslint-disable func-names, space-before-function-paren, no-var, consistent-return, no-new, prefer-arrow-callback, no-return-assign, one-var, one-var-declaration-per-line, object-shorthand, no-else-return, newline-per-chained-call, no-shadow, vars-on-top, prefer-template, max-len */








var Project = function () {
  function Project() {
    _classCallCheck(this, Project);

    var $cloneOptions = $('ul.clone-options-dropdown');
    var $projectCloneField = $('#project_clone');
    var $cloneBtnText = $('a.clone-dropdown-btn span');

    var selectedCloneOption = $cloneBtnText.text().trim();
    if (selectedCloneOption.length > 0) {
      $('a:contains(\'' + selectedCloneOption + '\')', $cloneOptions).addClass('is-active');
    }

    $('a', $cloneOptions).on('click', function (e) {
      var $this = $(e.currentTarget);
      var url = $this.attr('href');
      var activeText = $this.find('.dropdown-menu-inner-title').text();

      e.preventDefault();

      $('.is-active', $cloneOptions).not($this).removeClass('is-active');
      $this.toggleClass('is-active');
      $projectCloneField.val(url);
      $cloneBtnText.text(activeText);

      return $('.clone').text(url);
    });
    // Ref switcher
    Project.initRefSwitcher();
    $('.project-refs-select').on('change', function () {
      return $(this).parents('form').submit();
    });
    $('.hide-no-ssh-message').on('click', function (e) {
      __WEBPACK_IMPORTED_MODULE_0_js_cookie___default.a.set('hide_no_ssh_message', 'false');
      $(this).parents('.no-ssh-key-message').remove();
      return e.preventDefault();
    });
    $('.hide-no-password-message').on('click', function (e) {
      __WEBPACK_IMPORTED_MODULE_0_js_cookie___default.a.set('hide_no_password_message', 'false');
      $(this).parents('.no-password-message').remove();
      return e.preventDefault();
    });
    Project.projectSelectDropdown();
  }

  _createClass(Project, null, [{
    key: 'projectSelectDropdown',
    value: function projectSelectDropdown() {
      Object(__WEBPACK_IMPORTED_MODULE_5__project_select__["a" /* default */])();
      $('.project-item-select').on('click', function (e) {
        return Project.changeProject($(e.currentTarget).val());
      });
    }
  }, {
    key: 'changeProject',
    value: function changeProject(url) {
      return window.location = url;
    }
  }, {
    key: 'initRefSwitcher',
    value: function initRefSwitcher() {
      var refListItem = document.createElement('li');
      var refLink = document.createElement('a');

      refLink.href = '#';

      return $('.js-project-refs-dropdown').each(function () {
        var $dropdown, selected;
        $dropdown = $(this);
        selected = $dropdown.data('selected');
        return $dropdown.glDropdown({
          data: function data(term, callback) {
            __WEBPACK_IMPORTED_MODULE_3__lib_utils_axios_utils__["a" /* default */].get($dropdown.data('refsUrl'), {
              params: {
                ref: $dropdown.data('ref'),
                search: term
              }
            }).then(function (_ref) {
              var data = _ref.data;
              return callback(data);
            }).catch(function () {
              return Object(__WEBPACK_IMPORTED_MODULE_4__flash__["a" /* default */])(Object(__WEBPACK_IMPORTED_MODULE_1__locale__["a" /* __ */])('An error occurred while getting projects'));
            });
          },

          selectable: true,
          filterable: true,
          filterRemote: true,
          filterByText: true,
          inputFieldName: $dropdown.data('inputFieldName'),
          fieldName: $dropdown.data('fieldName'),
          renderRow: function renderRow(ref) {
            var li = refListItem.cloneNode(false);

            if (ref.header != null) {
              li.className = 'dropdown-header';
              li.textContent = ref.header;
            } else {
              var link = refLink.cloneNode(false);

              if (ref === selected) {
                link.className = 'is-active';
              }

              link.textContent = ref;
              link.dataset.ref = ref;

              li.appendChild(link);
            }

            return li;
          },
          id: function id(obj, $el) {
            return $el.attr('data-ref');
          },
          toggleLabel: function toggleLabel(obj, $el) {
            return $el.text().trim();
          },
          clicked: function clicked(options) {
            var e = options.e;

            e.preventDefault();
            if ($('input[name="ref"]').length) {
              var $form = $dropdown.closest('form');

              var $visit = $dropdown.data('visit');
              var shouldVisit = $visit ? true : $visit;
              var action = $form.attr('action');
              var divider = action.indexOf('?') === -1 ? '?' : '&';
              if (shouldVisit) {
                Object(__WEBPACK_IMPORTED_MODULE_2__lib_utils_url_utility__["g" /* visitUrl */])('' + action + divider + $form.serialize());
              }
            }
          }
        });
      });
    }
  }]);

  return Project;
}();

/* harmony default export */ __webpack_exports__["a"] = (Project);
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__("../../../node_modules/jquery/dist/jquery.js")))

/***/ }),

/***/ "./project_select.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function($) {/* harmony export (immutable) */ __webpack_exports__["a"] = projectSelect;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__api__ = __webpack_require__("./api.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__project_select_combo_button__ = __webpack_require__("./project_select_combo_button.js");
/* eslint-disable func-names, space-before-function-paren, wrap-iife, prefer-arrow-callback, no-var, comma-dangle, object-shorthand, one-var, one-var-declaration-per-line, no-else-return, quotes, max-len */



function projectSelect() {
  $('.ajax-project-select').each(function (i, select) {
    var placeholder;
    var simpleFilter = $(select).data('simpleFilter') || false;
    this.groupId = $(select).data('groupId');
    this.includeGroups = $(select).data('includeGroups');
    this.allProjects = $(select).data('allProjects') || false;
    this.orderBy = $(select).data('orderBy') || 'id';
    this.withIssuesEnabled = $(select).data('withIssuesEnabled');
    this.withMergeRequestsEnabled = $(select).data('withMergeRequestsEnabled');

    placeholder = "搜索项目";
    if (this.includeGroups) {
      placeholder += "或群组";
    }

    $(select).select2({
      placeholder: placeholder,
      minimumInputLength: 0,
      query: function (_this) {
        return function (query) {
          var finalCallback, projectsCallback;
          finalCallback = function finalCallback(projects) {
            var data;
            data = {
              results: projects
            };
            return query.callback(data);
          };
          if (_this.includeGroups) {
            projectsCallback = function projectsCallback(projects) {
              var groupsCallback;
              groupsCallback = function groupsCallback(groups) {
                var data;
                data = groups.concat(projects);
                return finalCallback(data);
              };
              return __WEBPACK_IMPORTED_MODULE_0__api__["a" /* default */].groups(query.term, {}, groupsCallback);
            };
          } else {
            projectsCallback = finalCallback;
          }
          if (_this.groupId) {
            return __WEBPACK_IMPORTED_MODULE_0__api__["a" /* default */].groupProjects(_this.groupId, query.term, projectsCallback);
          } else {
            return __WEBPACK_IMPORTED_MODULE_0__api__["a" /* default */].projects(query.term, {
              order_by: _this.orderBy,
              with_issues_enabled: _this.withIssuesEnabled,
              with_merge_requests_enabled: _this.withMergeRequestsEnabled,
              membership: !_this.allProjects
            }, projectsCallback);
          }
        };
      }(this),
      id: function id(project) {
        if (simpleFilter) return project.id;
        return JSON.stringify({
          name: project.name,
          url: project.web_url
        });
      },
      text: function text(project) {
        return project.name_with_namespace || project.name;
      },
      dropdownCssClass: "ajax-project-dropdown"
    });
    if (simpleFilter) return select;
    return new __WEBPACK_IMPORTED_MODULE_1__project_select_combo_button__["a" /* default */](select);
  });
}
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__("../../../node_modules/jquery/dist/jquery.js")))

/***/ }),

/***/ "./project_select_combo_button.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function($) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__lib_utils_accessor__ = __webpack_require__("./lib/utils/accessor.js");
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }



var ProjectSelectComboButton = function () {
  function ProjectSelectComboButton(select) {
    _classCallCheck(this, ProjectSelectComboButton);

    this.projectSelectInput = $(select);
    this.newItemBtn = $('.new-project-item-link');
    this.resourceType = this.newItemBtn.data('type');
    this.resourceLabel = this.newItemBtn.data('label');
    this.formattedText = this.deriveTextVariants();
    this.groupId = this.projectSelectInput.data('groupId');
    this.bindEvents();
    this.initLocalStorage();
  }

  _createClass(ProjectSelectComboButton, [{
    key: 'bindEvents',
    value: function bindEvents() {
      var _this = this;

      this.projectSelectInput.siblings('.new-project-item-select-button').on('click', function (e) {
        return _this.openDropdown(e);
      });

      this.newItemBtn.on('click', function (e) {
        if (!_this.getProjectFromLocalStorage()) {
          e.preventDefault();
          _this.openDropdown(e);
        }
      });

      this.projectSelectInput.on('change', function () {
        return _this.selectProject();
      });
    }
  }, {
    key: 'initLocalStorage',
    value: function initLocalStorage() {
      var localStorageIsSafe = __WEBPACK_IMPORTED_MODULE_0__lib_utils_accessor__["a" /* default */].isLocalStorageAccessSafe();

      if (localStorageIsSafe) {
        this.localStorageKey = ['group', this.groupId, this.formattedText.localStorageItemType, 'recent-project'].join('-');
        this.setBtnTextFromLocalStorage();
      }
    }

    // eslint-disable-next-line class-methods-use-this

  }, {
    key: 'openDropdown',
    value: function openDropdown(event) {
      $(event.currentTarget).siblings('.project-item-select').select2('open');
    }
  }, {
    key: 'selectProject',
    value: function selectProject() {
      var selectedProjectData = JSON.parse(this.projectSelectInput.val());
      var projectUrl = selectedProjectData.url + '/' + this.projectSelectInput.data('relativePath');
      var projectName = selectedProjectData.name;

      var projectMeta = {
        url: projectUrl,
        name: projectName
      };

      this.setNewItemBtnAttributes(projectMeta);
      this.setProjectInLocalStorage(projectMeta);
    }
  }, {
    key: 'setBtnTextFromLocalStorage',
    value: function setBtnTextFromLocalStorage() {
      var cachedProjectData = this.getProjectFromLocalStorage();

      this.setNewItemBtnAttributes(cachedProjectData);
    }
  }, {
    key: 'setNewItemBtnAttributes',
    value: function setNewItemBtnAttributes(project) {
      if (project) {
        this.newItemBtn.attr('href', project.url);
        this.newItemBtn.text(this.formattedText.defaultTextPrefix + ' in ' + project.name);
      } else {
        this.newItemBtn.text('\u9009\u62E9\u4E00\u4E2A\u9879\u76EE\u6765\u521B\u5EFA ' + this.formattedText.presetTextSuffix);
      }
    }
  }, {
    key: 'getProjectFromLocalStorage',
    value: function getProjectFromLocalStorage() {
      var projectString = localStorage.getItem(this.localStorageKey);

      return JSON.parse(projectString);
    }
  }, {
    key: 'setProjectInLocalStorage',
    value: function setProjectInLocalStorage(projectMeta) {
      var projectString = JSON.stringify(projectMeta);

      localStorage.setItem(this.localStorageKey, projectString);
    }
  }, {
    key: 'deriveTextVariants',
    value: function deriveTextVariants() {
      var defaultTextPrefix = this.resourceLabel;

      // the trailing slice call depluralizes each of these strings (e.g. new-issues -> new-issue)
      var localStorageItemType = 'new-' + this.resourceType.split('_').join('-').slice(0, -1);
      var presetTextSuffix = this.resourceType.split('_').join(' ').slice(0, -1);

      return {
        localStorageItemType: localStorageItemType, // new-issue / new-merge-request
        defaultTextPrefix: defaultTextPrefix, // New issue / New merge request
        presetTextSuffix: presetTextSuffix // issue / merge request
      };
    }
  }]);

  return ProjectSelectComboButton;
}();

/* harmony default export */ __webpack_exports__["a"] = (ProjectSelectComboButton);
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__("../../../node_modules/jquery/dist/jquery.js")))

/***/ }),

/***/ "./shortcuts_navigation.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_mousetrap__ = __webpack_require__("../../../node_modules/mousetrap/mousetrap.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_mousetrap___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_mousetrap__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__shortcuts_dashboard_navigation__ = __webpack_require__("./shortcuts_dashboard_navigation.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__shortcuts__ = __webpack_require__("./shortcuts.js");
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }





var ShortcutsNavigation = function (_Shortcuts) {
  _inherits(ShortcutsNavigation, _Shortcuts);

  function ShortcutsNavigation() {
    _classCallCheck(this, ShortcutsNavigation);

    var _this = _possibleConstructorReturn(this, (ShortcutsNavigation.__proto__ || Object.getPrototypeOf(ShortcutsNavigation)).call(this));

    __WEBPACK_IMPORTED_MODULE_0_mousetrap___default.a.bind('g p', function () {
      return Object(__WEBPACK_IMPORTED_MODULE_1__shortcuts_dashboard_navigation__["a" /* default */])('.shortcuts-project');
    });
    __WEBPACK_IMPORTED_MODULE_0_mousetrap___default.a.bind('g e', function () {
      return Object(__WEBPACK_IMPORTED_MODULE_1__shortcuts_dashboard_navigation__["a" /* default */])('.shortcuts-project-activity');
    });
    __WEBPACK_IMPORTED_MODULE_0_mousetrap___default.a.bind('g f', function () {
      return Object(__WEBPACK_IMPORTED_MODULE_1__shortcuts_dashboard_navigation__["a" /* default */])('.shortcuts-tree');
    });
    __WEBPACK_IMPORTED_MODULE_0_mousetrap___default.a.bind('g c', function () {
      return Object(__WEBPACK_IMPORTED_MODULE_1__shortcuts_dashboard_navigation__["a" /* default */])('.shortcuts-commits');
    });
    __WEBPACK_IMPORTED_MODULE_0_mousetrap___default.a.bind('g j', function () {
      return Object(__WEBPACK_IMPORTED_MODULE_1__shortcuts_dashboard_navigation__["a" /* default */])('.shortcuts-builds');
    });
    __WEBPACK_IMPORTED_MODULE_0_mousetrap___default.a.bind('g n', function () {
      return Object(__WEBPACK_IMPORTED_MODULE_1__shortcuts_dashboard_navigation__["a" /* default */])('.shortcuts-network');
    });
    __WEBPACK_IMPORTED_MODULE_0_mousetrap___default.a.bind('g d', function () {
      return Object(__WEBPACK_IMPORTED_MODULE_1__shortcuts_dashboard_navigation__["a" /* default */])('.shortcuts-repository-charts');
    });
    __WEBPACK_IMPORTED_MODULE_0_mousetrap___default.a.bind('g i', function () {
      return Object(__WEBPACK_IMPORTED_MODULE_1__shortcuts_dashboard_navigation__["a" /* default */])('.shortcuts-issues');
    });
    __WEBPACK_IMPORTED_MODULE_0_mousetrap___default.a.bind('g b', function () {
      return Object(__WEBPACK_IMPORTED_MODULE_1__shortcuts_dashboard_navigation__["a" /* default */])('.shortcuts-issue-boards');
    });
    __WEBPACK_IMPORTED_MODULE_0_mousetrap___default.a.bind('g m', function () {
      return Object(__WEBPACK_IMPORTED_MODULE_1__shortcuts_dashboard_navigation__["a" /* default */])('.shortcuts-merge_requests');
    });
    __WEBPACK_IMPORTED_MODULE_0_mousetrap___default.a.bind('g t', function () {
      return Object(__WEBPACK_IMPORTED_MODULE_1__shortcuts_dashboard_navigation__["a" /* default */])('.shortcuts-todos');
    });
    __WEBPACK_IMPORTED_MODULE_0_mousetrap___default.a.bind('g w', function () {
      return Object(__WEBPACK_IMPORTED_MODULE_1__shortcuts_dashboard_navigation__["a" /* default */])('.shortcuts-wiki');
    });
    __WEBPACK_IMPORTED_MODULE_0_mousetrap___default.a.bind('g s', function () {
      return Object(__WEBPACK_IMPORTED_MODULE_1__shortcuts_dashboard_navigation__["a" /* default */])('.shortcuts-snippets');
    });
    __WEBPACK_IMPORTED_MODULE_0_mousetrap___default.a.bind('i', function () {
      return Object(__WEBPACK_IMPORTED_MODULE_1__shortcuts_dashboard_navigation__["a" /* default */])('.shortcuts-new-issue');
    });

    _this.enabledHelp.push('.hidden-shortcut.project');
    return _this;
  }

  return ShortcutsNavigation;
}(__WEBPACK_IMPORTED_MODULE_2__shortcuts__["a" /* default */]);

/* harmony default export */ __webpack_exports__["a"] = (ShortcutsNavigation);

/***/ })

},["./pages/projects/index.js"]);


// WEBPACK FOOTER //
// pages.projects.127d3e2649bb1c3ba17f.bundle.js